import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Phone, Mail, Calendar, User } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import ashok from "../assets/drashoka.JPG";
import varsha from "../assets/drvarsha.JPG";
import naveen from "../assets/naveen.jpeg";
import shrusti from "../assets/shrusti.jpeg";
import shreedhar from "../assets/shreedhar.png";
import shivappa from "../assets/dr shivappa.jpg";
import arun from "../assets/dr arun.jpg";
import basav from "../assets/basav.png";
import prathmesh from "../assets/dr pratmesh hanchinal.jpg";
import vijay from "../assets/DR VIJAY MANTESH.jpg";
import kabade from "../assets/kabade.png";
import ashoka from "../assets/drashokgudagunti.png";
import somanath from "../assets/dr somanath.jpg";
import vijapur from "../assets/mvijapur.jpg";
import katti from "../assets/katti.jpeg";
import gurudappa from "../assets/gurudappa.jpeg";
import ramesh from "../assets/ramesh.jpeg";

const Consultants = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('All');

  const doctors = [
    {
      name: 'Dr. Ashok Bangarshettar',
      specialty: 'Orthopaedic Surgeon',
      qualification: 'MS (Ortho)',
      experience: '',
      image: ashok,
      description: '',
      availability: 'Mon-Sat: 9AM-6PM',
    },
    {
      name: 'Dr. Varsha Bangarshettar',
      specialty: 'Ophthalmologist',
      qualification: 'MS (Optho)',
      experience: '',
      image: varsha,
      description: '',
      availability: 'Mon-Sat: 10AM-5PM',
    },
    {
      name: 'Dr. Shrusthi Walad',
      specialty: 'Cardiologist',
      qualification: 'MD, DM (Cardiology)',
      experience: '',
      image: shrusti,
      description: '',
      availability: 'Mon-Sat: 9AM-6PM',
    },
    {
      name: 'Dr. Navin Pattanashetti',
      specialty: 'Nephrology',
      qualification: 'MD, DM(Nephrology)',
      experience: '',
      image: naveen,
      description: '',
      availability: 'Sunday 10AM-3PM',
    },
    {
      name: 'Dr. Shivappa A',
      specialty: 'Cardiothoranic Surgeon',
      qualification: 'MS, M.ch (CVTS)',
      experience: '',
      image: shivappa,
      description: '',
      availability: 'Mon-Fri: 11AM-4PM',
    },
    {
      name: 'Dr. Shreedhar D',
      specialty: 'OBG Specialist',
      qualification: 'MD (OBG)',
      experience: '',
      image: shreedhar,
      description: '',
      availability: 'Mon-Sat: 10AM-6PM',
    },
    {
      name: 'Dr. Arun W',
      specialty: 'General Surgeon',
      qualification: 'MS (Surgery)',
      experience: '',
      image: arun,
      description: '',
      availability: 'Tue-Sat: 9AM-5PM',
    },
    {
      name: 'Dr. Prathmesh Hanchanal',
      specialty: 'Orthopedic',
      qualification: 'MS (Ortho)',
      experience: '',
      image: prathmesh,
      description: '',
      availability: 'Mon-Sat: 1PM-3PM',
    },
    {
      name: 'Dr. Basavaraj Anushettar',
      specialty: 'Cardiothornic Surgeon',
      qualification: 'MS, M.ch',
      experience: '',
      image: basav,
      description: '',
      availability: 'Mon-Sat: Evening 5PM-7PM',
    },
    {
      name: 'Dr. Vijay Mahantesh Pujari',
      specialty: 'Neuro Surgeon',
      qualification: 'MS',
      experience: '',
      image: vijay,
      description: '',
      availability: 'Mon-Sat: Morning 2PM-5PM',
    },
    {
      name: 'Dr. D M Kabade',
      specialty: 'Physician',
      qualification: 'MD (Medicine)',
      experience: '',
      image: kabade,
      description: '',
      availability: 'Mon-Sat: Morning 12PM-1PM',
    },
    {
      name: 'Dr. Somanath',
      specialty: 'ENT',
      qualification: 'MS (ENT)',
      experience: '',
      image: somanath,
      description: '',
      availability: 'Mon-Sat: Afternoon 1PM-2PM',
    },
    {
      name: 'Dr. Ashok Gudaganti',
      specialty: 'Pulmonologist',
      qualification: 'MBBS, MD (Pulmonologist)',
      experience: '',
      image: ashoka,
      description: '',
      availability: 'Mon-Sat: Afternoon 3PM-4PM',
    },
    {
      name: 'Dr. Manjunath B',
      specialty: 'Maxillofacial Surgeon',
      qualification: 'MDS, BDS',
      experience: '',
      image: vijapur,
      description: '',
      availability: 'Mon-Fri: 10AM-5PM',
    },
    {
      name: 'Dr. Pavan Katti',
      specialty: 'Urologist',
      qualification: 'Mch (Urology)',
      experience: '',
      image: katti,
      description: '',
      availability: 'Mon-Sat: 1PM-2PM',
    },
    {
      name: 'Dr. Ramesh Hosamani',
      specialty: 'General Surgeon',
      qualification: 'MS (Sergery)',
      experience: '',
      image: ramesh,
      description: '',
      availability: 'Mon-Sat: 12PM-2PM',
    },
    {
      name: 'Dr. Gurupadappa P',
      specialty: 'Neurlogist',
      qualification: 'Mch',
      experience: '',
      image: gurudappa,
      description: '',
      availability: 'Mon-Sat: Afternoon 1PM-2PM',
    },
  ];

  const specialties = ['All', ...new Set(doctors.map((doc) => doc.specialty))];

  const filteredDoctors = doctors.filter((doctor) => {
    const matchesSearch =
      doctor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      doctor.specialty.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesSpecialty = selectedSpecialty === 'All' || doctor.specialty === selectedSpecialty;
    return matchesSearch && matchesSpecialty;
  });

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <img
          src="https://images.pexels.com/photos/7089625/pexels-photo-7089625.jpeg"
          alt="Consultants"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-sky-900/90 to-blue-900/70"></div>
        <div className="relative z-10 container mx-auto px-4 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-bold text-white mb-4"
          >
            Our <span className="text-sky-300">Consultants</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-white/90 max-w-2xl mx-auto"
          >
            Meet our team of highly qualified and experienced medical professionals
          </motion.p>
        </div>
      </section>

      {/* Search and Filter */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-4 top-1/2 lg:top-6 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  type="text"
                  placeholder="Search by name or specialty..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-12 h-12 border-gray-300 focus:border-sky-400"
                />
              </div>

              {/* Specialty Filter */}
              <div className="flex gap-2 overflow-x-auto pb-2">
                {specialties.map((specialty) => (
                  <button
                    key={specialty}
                    onClick={() => setSelectedSpecialty(specialty)}
                    className={`px-6 py-3 rounded-full font-medium whitespace-nowrap transition-all ${
                      selectedSpecialty === specialty
                        ? 'bg-sky-500 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {specialty}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Grid */}
      <section className="py-20 bg-gradient-to-b from-sky-50 to-white">
        <div className="container mx-auto px-4">
          {filteredDoctors.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-xl text-gray-600">No consultants found matching your criteria.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredDoctors.map((doctor, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Card className="border-none shadow-xl hover:shadow-2xl transition-all overflow-hidden group h-full">
                    {/* Doctor Image */}
                    <div className="relative h-80 overflow-hidden">
                      <div className="relative h-80 overflow-hidden bg-gradient-to-br from-sky-200 to-blue-300 flex items-center justify-center">
                        {doctor.image ? (
                          <img
                            src={doctor.image}
                            alt={doctor.name}
                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                          />
                        ) : (
                          <div className="flex flex-col items-center justify-center text-white">
                            <User className="w-24 h-24 opacity-80" />
                            <p className="mt-3 text-lg font-semibold opacity-90">
                              {doctor.name}
                            </p>
                          </div>
                        )}

                        {/* Gradient overlay */}
                        {/* <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div> */}

                        {/* Name & specialty */}
                        <div className="absolute bottom-4 left-4 right-4">
                          <h3 className="text-2xl font-bold text-white mb-1">{doctor.name}</h3>
                          <p className="text-sky-300 font-medium">{doctor.specialty}</p>
                        </div>

                        {/* Experience badge */}
                        <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full">
                          <p className="text-white text-sm font-medium">{doctor.experience}</p>
                        </div>
                      </div>

                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <h3 className="text-2xl font-bold text-white mb-1">{doctor.name}</h3>
                        <p className="text-sky-300 font-medium">{doctor.specialty}</p>
                      </div>
                      <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full">
                        <p className="text-white text-sm font-medium">{doctor.experience}</p>
                      </div>
                    </div>

                    {/* Doctor Info */}
                    <CardContent className="p-6">
                      <div className="mb-4">
                        <p className="text-gray-600 text-sm font-medium mb-1">Qualification</p>
                        <p className="text-gray-800 font-semibold">{doctor.qualification}</p>
                      </div>

                      <p className="text-gray-600 mb-4 leading-relaxed text-sm">{doctor.description}</p>

                      <div className="flex items-center gap-2 text-sm text-gray-600 mb-6">
                        <Calendar className="w-4 h-4 text-sky-500" />
                        <span>{doctor.availability}</span>
                      </div>

                      {/* <div className="flex gap-2">
                        <Button className="flex-1 bg-sky-500 hover:bg-sky-600 text-white">
                          <Phone className="w-4 h-4 mr-2" />
                          Call
                        </Button>
                        <Button
                          variant="outline"
                          className="flex-1 border-sky-500 text-sky-500 hover:bg-sky-50"
                        >
                          <Calendar className="w-4 h-4 mr-2" />
                          Book
                        </Button>
                      </div> */}
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-sky-500 to-blue-600 rounded-3xl p-12 text-white text-center shadow-2xl"
          >
            <h2 className="text-4xl font-bold mb-4">Schedule Your Consultation</h2>
            <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
              Book an appointment with our experienced consultants today
            </p>
            <a href="/contact">
              <Button className="bg-white text-sky-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full shadow-xl">
                Book Appointment Now
              </Button>
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Consultants;